// extracted by mini-css-extract-plugin
module.exports = {"container":"monitoring_container__1SOXw","details":"monitoring_details__3R1U4"};